import React from 'react';

import CreateNewGroupBtn from 'pages/Profile/components/NewGroupBtn';

import styles from './styles.module.css';

const NoGroups = () => {
	return (
		<div className={styles.groupsEmpty}>
			<h4>No groups created yet</h4>
			<div className={styles.txt}>
				Get started by creating a group to organize your crew members. Add a name, select members,
				and provide a description to manage them efficiently
			</div>
			<CreateNewGroupBtn />
		</div>
	);
};

export default NoGroups;
